module.exports = __webpack_public_path__ + "images/financial-world-1542ca.png";